import React from 'react';
import { Content as RightRailContent } from '../../gs-component-right-rail';
import GuestList from '../GuestList';
import ContactInfo from '../ContactInfo';
import Notes, { RsvpNotes } from '../Notes';
import Gifts from '../Gifts';
import styles from './styles.scss';
import { ModalType, Person, Event, Invitation, FocusOn } from '../interfaces';

interface ContentProps {
  type: ModalType;
  focusOn: FocusOn;
  people: Person[];
  rsvpNote: string;
  events: Event[];
  invitations: Invitation[];
  displayFullAddress: boolean;
  selectedEvent?: Event;
}

const Content: React.FC<ContentProps> = ({
  people,
  type,
  focusOn,
  rsvpNote,
  events,
  invitations,
  selectedEvent,
  displayFullAddress,
}) => {
  const leaderIndex = people.findIndex(({ isLeader }) => isLeader);
  return (
    <RightRailContent className={styles.content}>
      <GuestList
        people={people}
        leaderIndex={leaderIndex}
        events={events}
        selectedEvent={selectedEvent}
        focusOn={focusOn}
      />
      <ContactInfo leaderIndex={leaderIndex} displayFullAddress={displayFullAddress} focusOn={focusOn} />
      {focusOn === FocusOn.all && <Notes />}
      {!!rsvpNote && !focusOn && <RsvpNotes />}
      {type === ModalType.edit && focusOn === FocusOn.all && <Gifts invitations={invitations} events={events} />}
    </RightRailContent>
  );
};

export default Content;
